import { __require as requireACallable } from './node_modules-core-js-internals-a-callable.js';
import { __require as requireIsNullOrUndefined } from './node_modules-core-js-internals-is-null-or-undefined.js';

var getMethod;
var hasRequiredGetMethod;

function requireGetMethod () {
	if (hasRequiredGetMethod) return getMethod;
	hasRequiredGetMethod = 1;
	var aCallable = requireACallable();
	var isNullOrUndefined = requireIsNullOrUndefined();

	// `GetMethod` abstract operation
	// https://tc39.es/ecma262/#sec-getmethod
	getMethod = function (V, P) {
	  var func = V[P];
	  return isNullOrUndefined(func) ? undefined : aCallable(func);
	};
	return getMethod;
}

export { requireGetMethod as __require };
//# sourceMappingURL=node_modules-core-js-internals-get-method.js.map
